// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { SKIP_LOADER } from '../services/loader-context.token';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    constructor(private loadingService: LoadingService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const skipLoader = req.context.get(SKIP_LOADER);

        if (!skipLoader) {
            this.loadingService.show();
        }

        return next.handle(req).pipe(
            finalize(() => {
                if (!skipLoader) {
                    this.loadingService.hide();
                }
            })
        );
    }
}
